import { lazy } from 'react';

// project import
import Loadable from 'components/Loadable';
import GuestLayout from 'layout/GuestLayout';

// Public Recordings
const Recordings = Loadable(lazy(() => import('pages/public-recordings')));
const Record = Loadable(lazy(() => import('pages/public-recordings/record')));

// Interviews
const ViewRequisition = Loadable(lazy(() => import('pages/interviews/requisition')));
const ViewApplication = Loadable(lazy(() => import('pages/interviews/requisition/application')));
const SubmitVideoQuestion = Loadable(lazy(() => import('pages/interviews/video-question')));
const SubmitVideoQuestionTest = Loadable(lazy(() => import('pages/interviews/video-question-test')));
const SubmitResumeProfile = Loadable(lazy(() => import('pages/interviews/resume-profile')));
const SubmitResumeProfileTest = Loadable(lazy(() => import('pages/interviews/resume-profile-test')));
const SubmitTypingAssessment = Loadable(lazy(() => import('pages/interviews/typing-assessment')));
const SubmitTypingAssessmentTest = Loadable(lazy(() => import('pages/interviews/typing-assessment-test')));

// Talent Discovery
const TalentDiscoveryFormSelection = Loadable(lazy(() => import('pages/talent-discovery')));
const TalentDiscoveryNonAgentForm = Loadable(lazy(() => import('pages/talent-discovery/non-agent-form')));
const TalentDiscoveryAgentForm = Loadable(lazy(() => import('pages/talent-discovery/agent-form')));

// ==============================|| MAIN ROUTING ||============================== //

const PublicRoutes = {
  path: '/',
  element: <GuestLayout />,
  children: [
    {
      path: 'public-recordings',
      children: [
        {
          path: '',
          element: <Recordings />
        },
        {
          path: 'record',
          element: <Record />
        }
      ]
    },
    {
      path: 'interviews',
      children: [
        {
          path: 'requisition/:requisitionId',
          element: <ViewRequisition />,
          handle: {
            breadcrumb: 'Job Description'
          }
        },
        {
          path: 'requisition/:requisitionId/:applicantId',
          element: <ViewApplication />,
          handle: {
            breadcrumbLoading: true
          }
        },
        {
          path: 'video-question/:id',
          element: <SubmitVideoQuestion />,
          handle: {
            breadcrumb: 'Video Interview'
          }
        },
        {
          path: 'video-question-test/:id',
          element: <SubmitVideoQuestionTest />,
          handle: {
            breadcrumb: 'Video Interview Test'
          }
        },
        {
          path: 'resume-profile/:id',
          element: <SubmitResumeProfile />,
          handle: {
            breadcrumb: 'Resume Profile'
          }
        },
        {
          path: 'resume-profile-test/:id',
          element: <SubmitResumeProfileTest />,
          handle: {
            breadcrumb: 'Resume Profile Test'
          }
        },
        {
          path: 'typing-assessment/:id',
          element: <SubmitTypingAssessment />,
          handle: {
            breadcrumb: 'Typing Assessment'
          }
        },
        {
          path: 'typing-assessment-test/:id',
          element: <SubmitTypingAssessmentTest />,
          handle: {
            breadcrumb: 'Typing Assessment Test'
          }
        }
      ]
    },
    {
      path: 'talent-discovery-hiring-form',
      children: [
        {
          path: '',
          element: <TalentDiscoveryFormSelection />,
          handle: {
            breadcrumb: false
          }
        },
        {
          path: 'non-agent',
          element: <TalentDiscoveryNonAgentForm />,
          handle: {
            breadcrumb: false
          }
        },
        {
          path: 'agent',
          element: <TalentDiscoveryAgentForm />,
          handle: {
            breadcrumb: false
          }
        }
      ]
    }
  ]
};

export default PublicRoutes;
